import type { ErrorSurfacingOptions, HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type { GetDriftCauseGroupsQueryParams, GetDriftCauseGroupsResponse } from 'types/drift.types';

export default (client: HttpClient) => ({
  getDriftCauseGroups: (
    { projectIds, ...params }: GetDriftCauseGroupsQueryParams,
    { hideNotification, hidePayGateModal }: ErrorSurfacingOptions = {}
  ) =>
    client
      .get<GetDriftCauseGroupsResponse>('drift-causes', {
        params: { ...params, projectIds: projectIds?.length ? projectIds.join(',') : undefined },
        hideNotification,
        hidePayGateModal
      })
      .then(returnData)
});
